import { ECategoryType } from "app/common/services/categoryService.types";
import type { ICustomCategoryResponse } from "app/services/category/userCustomCategoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

import type { IDomains } from "../MarketBuilder.types";

export const createMarket = (
    marketName: string,
    domains: IDomains,
    countryId: number,
): Promise<ICustomCategoryResponse[]> => {
    const entitiesArr = [],
        segmentsArr = [];
    domains.forEach((entity) => {
        const { type, id, domain } = entity;
        type === EAssetType.Segment ? segmentsArr.push(id) : entitiesArr.push(domain);
    });

    const createMarketPromise = UserCustomCategoryService.addCustomCategory({
        name: marketName,
        domains: entitiesArr,
        categoryType: ECategoryType.MARKET_LIST,
        country: countryId,
        segments: segmentsArr,
    });
    return createMarketPromise;
};
